import React, { useState, useEffect } from "react";
// utils
import FormButton from "../../button/FormButton";
import { FormikTextInput } from "../../inputs/FormikInputs";
import CommonForm from "../CommonForm";
// functions
import { postTipoDeImagen, deleteTipoDeImagen, updateTipoDeImagen } from './TiposDeImagenFunctions';
import { handleResponse } from "../../../../services/Local-services";
// validaciones
import { formikValidation } from './TiposDeImagenFormValidaciones';
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { userCredentials, formIsOpen, rowSelected, snackbarData, formData } from '../../../../recoilState/GlobalState';

export default function TiposDeImagenForm(props) {
    const [newTipoDeImagen, setNewTipoDeImagen] = useState({});
    const [inRequest, setInRequest] = useState(false);

    const setIsOpen = useSetRecoilState(formIsOpen);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const [selected, setSelected] = useRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const data = useRecoilValue(formData);

    const { titles, updateList, procede } = props.props;

    async function handleAction() {
        const functions = { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList };
        if (procede === 'Deleteone') {
            const response = await deleteTipoDeImagen(credentials, selected.row, setInRequest);
            return handleResponse(response, 'Tipo de imagen eliminado exitosamente', functions);
        }
        if (procede === 'Addone') {
            const response = await postTipoDeImagen(credentials, newTipoDeImagen, setInRequest)
            return handleResponse(response, 'Tipo de imagen añadido exitosamente', functions);
        }
        if (procede === 'Editone') {
            const response = await updateTipoDeImagen(credentials, newTipoDeImagen, selected.row, setInRequest)
            return handleResponse(response, 'Tipo de imagen modificado exitosamente', functions);
        }
    };

    useEffect(() => {
        if (procede !== 'Deleteone') handleAction();
    }, [newTipoDeImagen])

    const formik = formikValidation(setNewTipoDeImagen, selected.row, titles);
    const disabled = inRequest || procede === 'Deleteone';

    return (
        <CommonForm
            onSubmit={formik.handleSubmit}
            title={data.title}
            procede={procede}
        >
            <FormikTextInput
                data={data}
                name="nombre"
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name="codigo"
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name="bucket"
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name="folder"
                formik={formik}
                disabled={disabled}
            />
            <FormButton
                inRequest={inRequest}
                handleAction={handleAction}
            />
        </CommonForm>
    );
};